<template>
  <el-table
    :data="files"
    style="width: 100%">
    <el-table-column
      prop="type"
      label="File Name">
    </el-table-column>
    <el-table-column
      prop="extension"
      label="Extension">
    </el-table-column>
    <el-table-column
      prop="uploaded_on"
      label="Uploaded Date">
    </el-table-column>
    <el-table-column
      prop="updated_on"
      label="Updated Date">
    </el-table-column>
  </el-table>
</template>

<script>

export default {
  name: 'UploadedFiles',
  computed: {
    files() {
      return this.$store.state.MerchantFiles.files;
    },
  },
  async mounted() {
    await this.$store.dispatch('MerchantFiles/fetchUploadedFiles');
  },
};
</script>

<style scoped>

</style>
